/* eslint-disable no-loop-func */
import React, {
  useState,
  useRef,
  ChangeEvent,
  useCallback,
  useContext,
} from 'react';
import './InputWithUpload.css';
import { Progress, Icon, Button, Switch, MenuButton } from '@alifd/next';
import axios from 'axios';
import { BefGlobalContext, BefMessageServiceContext } from '@beflam/bef-core';

export interface InputWithUploadProps {
  style?: any;
  response?: any;
  position?: 'top' | 'bottom' | 'left' | 'right';
  sendState?: any;
  chatId?: any;
  viewType?: string;
  defaultText?: string;
  intentionMode?: string;
  reasoning?: boolean;
  onIntentionModeChange?: any;
  onReasoningChange?: any;
}

//防止主界面侧边栏高度计算问题
let showAiFuction = false;
setTimeout(() => {
  showAiFuction = true;
}, 100);

const InputWithUpload: React.FC<InputWithUploadProps> = ({
  response,
  position = 'top',
  sendState = 'send',
  chatId = {},
  viewType = 'chat',
  defaultText = '',
  intentionMode = 'Auto',
  reasoning = false,
  onIntentionModeChange,
  onReasoningChange,
  ...otherProps
}) => {
  const [text, setText] = useState(defaultText);
  // const [uploadFile, setUploadFile] = useState(null) as any;
  const [uploadFiles, setUploadFiles] = useState([]) as any;
  const uploadFilesRef = useRef<any[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const imageInputRef = useRef<HTMLInputElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [isComposing, setIsComposing] = useState(false);
  const [visible, setVisible] = useState(false);
  const [thinkTooltipVisible, setThinkTooltipVisible] = useState(false);
  const [progress, setProgress] = useState({}) as any;
  const [uploadState, setUploadState] = useState({}) as any;
  const [uploadFileIds, setUploadFileIds] = useState({}) as any;
  const [chatIdWithFile, setChatIdWithFile] = useState(chatId) as any;
  const MAX_FILE_SIZE = 50 * 1024 * 1024;

  const sGlobal = useContext(BefGlobalContext) as any;
  const messageService = useContext(BefMessageServiceContext);

  React.useEffect(() => {
    uploadFilesRef.current = uploadFiles;
  }, [uploadFiles]);

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && !isComposing) {
      e.preventDefault();
      if (inputRef.current && inputRef.current.value.length > 0) {
        inputRef.current.value = '';
        inputRef.current.style.height = 'auto';
        inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
        PushClick(false);
      }
    }
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  const handleFileUpload = (
    e: ChangeEvent<HTMLInputElement>,
    type: 'image' | 'file',
  ) => {
    const files = e.target.files;
    if (!files) return;
    const selectedFiles = e.target.files;
    processFiles(selectedFiles);
  };

  const PushClick = (button = true) => {
    if (button && sendState === 'stop') {
      response?.(text, { stopload: true });
      return;
    }
    let nowUploadFileIds: any[] = [];
    for (let index = 0; index < uploadFiles.length; index++) {
      const uploadFile = uploadFiles[index];
      nowUploadFileIds = nowUploadFileIds.concat(
        uploadFileIds[uploadFile.fileName],
      );
    }
    let uploadSuccess = 0;
    if (uploadFiles.length > 0) {
      uploadFiles.forEach((uploadfile: any) => {
        if (uploadState[uploadfile.fileName] === 'done') {
          uploadSuccess++;
        }
      });
      if (uploadFiles.length !== uploadSuccess) {
        response?.('请确保文件均上传完成', { waitingForUpload: true });
        return;
      }
    }

    response?.(text, {
      fileIds: nowUploadFileIds,
      files: uploadFiles,
      chatId: chatIdWithFile,
      reasoning: viewType === '' ? reasoning : false,
      intentionMode: intentionMode,
    });
    if (uploadFiles.length > 0) {
      setUploadFiles([]);
      setUploadFileIds({});
      setProgress({});
      setUploadState({});
      setText('');
      return;
    }
    setText('');
  };

  const removeFile = (fileName: string) => {
    const nowUploadFiles = uploadFiles.filter(
      (item: any) => item.fileName !== fileName,
    );
    setUploadFiles(nowUploadFiles);
    setUploadState((prev: any) => {
      const next = { ...prev };
      delete next[fileName];
      return next;
    });
    setProgress((prev: any) => {
      const next = { ...prev };
      delete next[fileName];
      return next;
    });
    setUploadFileIds((prev: any) => {
      const next = { ...prev };
      delete next[fileName];
      return next;
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleDragEnter = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (inputRef.current) {
      inputRef.current.blur();
    }
  }, []);

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (inputRef.current && inputRef.current !== document.activeElement) {
      inputRef.current.focus();
    }
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.dataTransfer.files.length > 0) {
        const selectedFiles = e.dataTransfer.files;
        processFiles(selectedFiles);
      }
    },
    [uploadFiles],
  );

  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    const clipboardData = e.clipboardData;
    if (!clipboardData) return;
    const pastedFiles: File[] = [];
    // clipboardData.files 对多文件粘贴更可靠
    if (clipboardData.files && clipboardData.files.length > 0) {
      for (let i = 0; i < clipboardData.files.length; i++) {
        pastedFiles.push(clipboardData.files[i]);
      }
    } else if (clipboardData.items) {
      for (let i = 0; i < clipboardData.items.length; i++) {
        const item = clipboardData.items[i];
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file) pastedFiles.push(file);
        }
      }
    }
    if (pastedFiles.length > 0) {
      e.preventDefault();
      processFiles(pastedFiles);
    }
  };

  const compressImage = (file: File): Promise<File> => {
    const IMAGE_SIZE_THRESHOLD = 500 * 1024; // 500KB 以下跳过压缩
    const MAX_DIMENSION = 1920;
    const QUALITY = 0.85;

    if (!file.type.startsWith('image/') || file.size <= IMAGE_SIZE_THRESHOLD) {
      return Promise.resolve(file);
    }

    return new Promise((resolve) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(url);
        let { width, height } = img;
        if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
          if (width >= height) {
            height = Math.round((height * MAX_DIMENSION) / width);
            width = MAX_DIMENSION;
          } else {
            width = Math.round((width * MAX_DIMENSION) / height);
            height = MAX_DIMENSION;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(img, 0, 0, width, height);
        const outputType =
          file.type === 'image/png' ? 'image/png' : 'image/jpeg';
        canvas.toBlob(
          (blob) => {
            if (blob && blob.size < file.size) {
              resolve(new File([blob], file.name, { type: outputType }));
            } else {
              resolve(file);
            }
          },
          outputType,
          QUALITY,
        );
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      img.src = url;
    });
  };

  const processFiles = async (files: any) => {
    //配置并上传
    let newUploadFiles: {
      file: any;
      fileName: string;
    }[] = [];
    let maxSizeFileNames = '';
    for (let index = 0; index < files.length; index++) {
      let file = files[index];
      const fileName = file.name || Math.random().toString(36).slice(-8);
      if (file.size > MAX_FILE_SIZE) {
        maxSizeFileNames +=
          (maxSizeFileNames.length > 0 ? ', ' : '') + fileName;
        continue;
      }
      let isSameFile = false;
      for (let j = 0; j < uploadFilesRef.current.length; j++) {
        if (uploadFilesRef.current[j].file == file) {
          isSameFile = true;
          break;
        }
      }
      if (isSameFile) continue;

      let finalFileName: string = fileName;
      const existingFileNames = [
        ...uploadFilesRef.current.map((f: any) => f.fileName),
        ...newUploadFiles.map((f) => f.fileName),
      ];
      if (existingFileNames.includes(finalFileName)) {
        const lastDotIndex = fileName.lastIndexOf('.');
        const baseName =
          lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
        const ext = lastDotIndex > 0 ? fileName.substring(lastDotIndex) : '';
        let counter = 1;
        while (existingFileNames.includes(`${baseName}(${counter})${ext}`)) {
          counter++;
        }
        finalFileName = `${baseName}(${counter})${ext}`;
      }
      file = await compressImage(file);
      newUploadFiles.push({
        file,
        fileName: finalFileName,
      });
      uploadFilesRef.current = [
        ...uploadFilesRef.current,
        { file, fileName: finalFileName },
      ];
      setUploadState((prev: any) => ({ ...prev, [finalFileName]: 'pending' }));
    }
    if (maxSizeFileNames.length > 0) {
      messageService.showMessage(
        messageService.handleErr(
          '以下文件超过50MB, 请重新选择: ' + maxSizeFileNames,
          '文件上传',
        ),
      );
    }
    setUploadFiles((prev: any) => [...prev, ...newUploadFiles]);
    uploadFileWithProgresses(newUploadFiles);
  };

  const uploadFileWithProgresses = async (files: any) => {
    let conversationId = chatIdWithFile.conversationId;

    for (let index = 0; index < files.length; index++) {
      const file = files[index].file;
      const fileName = files[index].fileName;
      const formData = new FormData();
      formData.append('file', file, fileName);
      formData.append('type', viewType);
      formData.append('conversationId', conversationId);

      formData.append('sessionId', sGlobal.session.id);

      try {
        const response = await axios.post(
          sGlobal.config.host + '/api/agent/upload',
          formData,
          {
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                const progress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total,
                );
                setUploadState((prev: any) => ({
                  ...prev,
                  [files[index].fileName]: 'uploading',
                }));
                setProgress((prev: any) => ({
                  ...prev,
                  [files[index].fileName]: progress,
                }));
              }
            },
          },
        );
        if (
          response.data &&
          response.data.conversationId &&
          conversationId !== response.data.conversationId
        ) {
          conversationId = response.data.conversationId;
          setChatIdWithFile((prev: any) => ({
            ...prev,
            conversationId: conversationId,
          }));
        }
        handleUploadSuccess(response.data, files[index].fileName);
      } catch (error) {
        handleUploadSuccess({ success: false }, files[index].fileName);
      }
    }
  };

  function handleUploadSuccess(responseData: any, fileName: string) {
    if (responseData.success) {
      setUploadState((prev: any) => ({ ...prev, [fileName]: 'done' }));
      setProgress((prev: any) => ({ ...prev, [fileName]: 100 }));
      setUploadFileIds((prev: any) => ({
        ...prev,
        [fileName]: responseData.fileIds,
      }));
    } else {
      setUploadState((prev: any) => ({ ...prev, [fileName]: 'error' }));
      setProgress((prev: any) => ({ ...prev, [fileName]: 0 }));
    }
  }

  const getFilesView = (uploadFiles: any) => {
    const fileRow = [] as any;
    if (uploadFiles && uploadFiles.length > 0) {
      uploadFiles.forEach((uploadFile: any) => {
        fileRow.push(
          <div
            style={{
              height: 50,
              marginBottom: 8,
              width: 200,
              minWidth: 200,
              maxWidth: 200,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Icon
                type={
                  uploadState[uploadFile.fileName] === 'done'
                    ? 'success'
                    : 'attachment'
                }
                style={{
                  marginRight: 8,
                  color:
                    uploadState[uploadFile.fileName] === 'done'
                      ? 'green'
                      : 'black',
                }}
              />
              <span
                style={{
                  flex: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {uploadFile.fileName}
              </span>
              <Button
                text
                onClick={() => removeFile(uploadFile.fileName)}
                style={{ marginRight: '20px' }}
              >
                <Icon type="close" />
              </Button>
            </div>
            <Progress
              percent={progress[uploadFile.fileName] || '0'}
              state={
                uploadState[uploadFile.fileName] === 'error'
                  ? 'error'
                  : 'normal'
              }
              size="small"
              style={{ margin: 0 }}
            />
          </div>,
        );
      });
      return (
        <div
          style={{
            height: 55,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            overflowY: 'hidden',
          }}
        >
          {fileRow}
        </div>
      );
    } else {
      return null;
    }
  };

  const onReasoningChanged = (checked: any) => {
    onReasoningChange(checked);
  };

  const { Item } = MenuButton;
  const IntentionMode = ['Auto', 'Biz', 'Page'].map((item) => (
    <Item key={item} style={{ overflow: 'hidden' }}>
      {item === 'Page' ? 'UI' : item === 'Biz' ? 'API' : item}
    </Item>
  ));

  const intentionEdit = (key: any) => {
    onIntentionModeChange(key);
  };

  return (
    <div
      className="chat-input-container"
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      {getFilesView(uploadFiles)}
      <div className="input-wrapper">
        <textarea
          value={text}
          ref={inputRef}
          onKeyDown={handleKeyDown}
          onChange={handleTextChange}
          placeholder="请输入..."
          rows={1}
          className="auto-resize"
          onFocus={(e) => {
            const val = e.target.value;
            e.target.value = ''; // 先清空
            e.target.value = val; // 再重新赋值，光标会自动跳到最后
          }}
          onCompositionStart={() => setIsComposing(true)}
          onCompositionEnd={() => setIsComposing(false)}
          onPaste={handlePaste}
        />
      </div>
      <div className="chat-function-setting">
        {showAiFuction && viewType === '' ? (
          <MenuButton
            label={
              intentionMode === 'Page'
                ? 'UI'
                : intentionMode === 'Biz'
                  ? 'API'
                  : intentionMode
            }
            className="chat-intention-itembutton"
            autoWidth
            onClick={(e) => {
              e.stopPropagation();
            }}
            onItemClick={(key) => intentionEdit(key)}
          >
            {IntentionMode}
          </MenuButton>
        ) : null}
        <div style={{ flex: 1 }}></div>
        {viewType === '' ? (
          <div className="chat-thinktooltip-container">
            <Switch
              autoWidth
              checked={reasoning}
              size="small"
              onMouseEnter={() => setThinkTooltipVisible(true)}
              onMouseLeave={() => {
                setThinkTooltipVisible(false);
              }}
              onChange={onReasoningChanged}
            />
            {thinkTooltipVisible && (
              <div className={'tooltip top'}>深度思考</div>
            )}
          </div>
        ) : null}
        <div className="chat-tooltip-container">
          <button
            className="tooltip-button"
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => {
              setVisible(false);
            }}
            onClick={() => fileInputRef.current?.click()}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4402 5.94065L7.24998 10.1309C6.52679 10.8541 6.52679 12.0266 7.24998 12.7498V12.7498C7.97317 13.473 9.1457 13.473 9.8689 12.7498L11.3093 11.3094L14.0592 8.55957L14.7139 7.90484C16.1603 6.45845 16.1603 4.1134 14.7139 2.66701V2.66701C13.2675 1.22062 10.9224 1.22062 9.47606 2.66701L3.97634 8.16673C1.80676 10.3363 1.80676 13.8539 3.97634 16.0235V16.0235C6.14592 18.1931 9.6635 18.193 11.8331 16.0235L16.6781 11.1785"
                stroke="#333333"
                stroke-width="1.48148"
              ></path>
            </svg>
            <input
              type="file"
              multiple
              className="upload-file"
              ref={fileInputRef}
              onChange={(e) => handleFileUpload(e, 'file')}
              // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              hidden
            />
          </button>
          {visible && <div className={'tooltip top'}>上传文件, 最大50M</div>}
        </div>
        <div className="upload-buttons">
          {/* <button onClick={() => imageInputRef.current?.click()}>
            图片
            <input
              type="file"
              className="upload-file"
              ref={imageInputRef}
              accept="image/*"
              onChange={(e) => handleFileUpload(e, 'image')}
              multiple
              hidden
            />
          </button> */}
          {sendState === 'send' &&
            (uploadFiles.length > 0 || text.length > 0) && (
              <button
                className="bef-chat-send-button"
                onClick={() => PushClick()}
              >
                发送
              </button>
            )}
          {sendState === 'stop' && (
            <button
              className="bef-chat-submit-button"
              aria-label="停止流式传输"
              data-testid="stop-button"
              onClick={() => PushClick()}
            >
              <img
                src="./assets/img/chatstop.jpeg"
                alt=""
                className="bef-chat-submit-img"
              />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InputWithUpload;
